import * as uuid from 'uuid';

import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Metatags, User } from '../utilidades/utilidades';

import { Inject, Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment.prod';
import { DOCUMENT } from '@angular/common';

@Injectable({providedIn: 'root'})
export class FuncionService {

	private currentUserSubject = new BehaviorSubject({
		session:false,
		username:"",
		security:{},
		nombre:"",
		saldo:"",
		puntos:"",
		suscrito:false,
		divisa:"",
		totalProductos:0
	});
	private currentUuidSubject = new BehaviorSubject("");
	private categoriasSubject = new BehaviorSubject([]);
	private newMensajeSubject = new BehaviorSubject(null);
	private newAlertaSubject = new BehaviorSubject(null);
	private sucursalesSubject = new BehaviorSubject([]);

	fnInformacionCliente( newUser ){
		this.fnRequestPost( environment.peticion.cargarInformacionCliente, {} )

		.subscribe( (response:any) =>{
			if( response.success ){

				
				newUser.nombre = response.informacion.nombre;
				newUser.saldo = response.informacion.saldo;
				newUser.puntos = response.informacion.puntos;
				newUser.suscrito = response.informacion.suscrito;
				newUser.divisa = response.informacion.divisa;
				newUser.totalProductos = response.informacion.totalProductos;

				if( response.informacion.uuid !== "" ){
					localStorage.setItem('currentUuid', response.informacion.uuid)
					this.currentUuidSubject.next( localStorage.getItem('currentUuid') );
				}

				this.currentUserSubject.next(newUser);
			}else{
				if( this.currentUserValue.session ){
					this.fnCerrarSesion( this.currentUserValue );
				}
			}
		});
	}

	constructor(
		private newHttp: HttpClient, 
		private newRouter:Router,
		private newMeta:Meta,
		@Inject(DOCUMENT) private doc
		){

		// localStorage.setItem('currentUuid', 'defbc018-f2ec-4833-8eba-55a036bc964c');

		if( !localStorage.getItem('currentUuid') ){
			this.createUuid();
		}else{
			this.currentUuidSubject.next( localStorage.getItem('currentUuid') );
		}

		var newUserData = localStorage.getItem("newUser");
		if( newUserData ){
			this.currentUserSubject.next(JSON.parse(newUserData));
			this.fnInformacionCliente( this.currentUserValue );
		}


		this.fnGetSucursales().subscribe( (response:any)=>{
			if( response.success ){
				this.cargarSucursales( response.lista );
			}
        });

	}

	createUuid(){
		let newUuid = uuid();
		localStorage.setItem('currentUuid', newUuid);
		this.currentUuidSubject.next( newUuid );
		return newUuid;
	}

	fnSetUuid( newUuid ){
		localStorage.setItem('currentUuid', newUuid);
		this.currentUuidSubject.next( newUuid );
	}
	
	fnUpdateMetas( newMetatags:Metatags ){
		this.newMeta.updateTag({ name: 'language', content: newMetatags.language });
		this.newMeta.updateTag({ name: 'author', content: newMetatags.author });
		this.newMeta.updateTag({ name: 'title', content: newMetatags.title });
		this.newMeta.updateTag({ name: 'description', content: newMetatags.description });
		if(newMetatags.keywords != ""){
			this.newMeta.updateTag({ name: 'keywords', content: newMetatags.keywords });
		}
		this.newMeta.updateTag({ property: 'og:site_name', content: "Pawerful Pet Shop" });
		this.newMeta.updateTag({ property: 'og:url', content: newMetatags.url });
		this.newMeta.updateTag({ property: 'og:title', content: newMetatags.title });
		this.newMeta.updateTag({ property: 'og:type', content: newMetatags.type });
		this.newMeta.updateTag({ property: 'og:description', content: newMetatags.description });
		this.newMeta.updateTag({ property: 'og:image', content: `${newMetatags.image}?v=${new Date().getTime()}` });
		this.newMeta.updateTag({ property: 'og:image:secure_url', content: newMetatags.image });
		this.newMeta.updateTag({ property: 'fb:app_id', content: "1852633541638518" });

		this.newMeta.updateTag({ name: 'twitter:title', content: newMetatags.title });
		this.newMeta.updateTag({ name: 'twitter:description', content: newMetatags.description });
		
		this.newMeta.updateTag({ name: 'twitter:card', content: "summary_large_image" });
		this.newMeta.updateTag({ name: 'twitterw:site', content: "@PawerfulMX" });
		this.newMeta.updateTag({ name: 'twitter:creator', content: "@PawerfulMX" });
		this.newMeta.updateTag({ name: 'twitter:text:title', content: newMetatags.title });
		this.newMeta.updateTag({ name: 'twitter:image', content: newMetatags.image });
		this.newMeta.updateTag({ name: 'robots', content: newMetatags.robots });
	}

	createLinkForCanonicalURL() {
		const head = this.doc.getElementsByTagName('head')[0];
	    var element: HTMLLinkElement= this.doc.querySelector(`link[rel='canonical']`) || null
	    if (element==null) {
	      element= this.doc.createElement('link') as HTMLLinkElement;
	      head.appendChild(element);
	    }
	    element.setAttribute('rel','canonical')
	    element.setAttribute('href',this.doc.URL.split("?")[0]);
	}
	


	public get currentUserValue(): User {
		return this.currentUserSubject.value;
	}

	public get currentUuidValue(): string{
		return this.currentUuidSubject.value;
	}

	fnRequestPost( path:string, params:any ){
		params.publicKey = environment.publicKey;
		if( this.currentUserValue.session ){
			const  headers = new  HttpHeaders().set("Authorization", `Bearer ${this.currentUserValue.security.access_token}`);
			return this.newHttp.post( `${environment.peticion.server}${path}`, params, {headers} );
		}else{
			return this.newHttp.post( `${environment.peticion.server}${path}`, params );	
		}
	}

	fnRequestGet( path:string, newUser:User ){
		if( this.currentUserValue.session ){
			const  headers = new  HttpHeaders().set("Authorization", `Bearer ${this.currentUserValue.security.access_token}`);
			return this.newHttp.get( environment.peticion.server + path, {headers} );
		}else{
			return this.newHttp.get( environment.peticion.server + path );
		}
	}

	fnUpdateToken(){
		const  headers = new  HttpHeaders().set("Content-Type", "application/x-www-form-urlencoded");
		return this.newHttp.post(`${environment.peticion.server}${environment.peticion.updateToken}`,`grant_type=refresh_token&refresh_token=${this.currentUserValue.security.refresh_token}`,{headers})
		.subscribe( (response:any) =>{
			this.currentUserValue.security = response;
			this.currentUserSubject.next(this.currentUserValue);
		})
	}

	fnVerifyUser( newUser:User ){
		if( newUser.security.roles.includes("ROLE_CLIENTE") ){
			newUser.session = true;
			localStorage.setItem("newUser", JSON.stringify(newUser));
			this.currentUserSubject.next(newUser);
			setTimeout(()=>{
				this.fnInformacionCliente( newUser );
			});
		}else{
			this.fnCerrarSesion( newUser );
		}
	}

	usuarioSesion():Observable<User>{
		return this.currentUserSubject.asObservable();
	}

	cargarSucursales( listaSucursales ){
		this.sucursalesSubject.next( listaSucursales );
	}

	listaSucursales():Observable<any>{
		return this.sucursalesSubject.asObservable();
	}

	cargarCategorias( listaCategorias ){
		this.categoriasSubject.next( listaCategorias );
	}

	listaCategorias():Observable<any>{
		return this.categoriasSubject.asObservable();
	}

	setNewMensaje( dataMensaje ){
		this.newMensajeSubject.next( dataMensaje );
	}

	getNewMensaje():Observable<any>{
		return this.newMensajeSubject.asObservable();
	}

	setNewAlerta( dataAlerta ){
		this.newAlertaSubject.next( dataAlerta );
	}

	getNewAlerta():Observable<any>{
		return this.newAlertaSubject.asObservable();
	}


	fnGetNotificationError(estatus: number) {
		this.setNewMensaje(null);
		if(estatus === 401){
			return environment.alerta.request.notFound;
		}else if (estatus === 512 || estatus === 513) {
			return environment.alerta.request.failExpired;
		} else if (estatus === 514) {
			return environment.alerta.request.failDisabled;
		} else if (estatus === 515) {
			return environment.alerta.request.failLocked;
		} else if (estatus === 516) {
			return environment.alerta.request.failBadCredentials;
		} else if (estatus === 500) {
			return environment.alerta.request.failBadRequest;
		} else if (estatus === 404) {
			return environment.alerta.request.failNotFound;
		}
	}


	fnIniciarSesion( newUser:any ){
		return this.fnRequestPost( environment.peticion.acceso, newUser );
	}

	fnCerrarSesion( newUser:User ){
		this.fnRequestGet( 'logout', newUser );
		localStorage.removeItem('newUser');
		localStorage.removeItem('currentUuid');
		localStorage.removeItem('suscripcion');
		localStorage.removeItem('cerrarSesion');
		this.createUuid();
		this.currentUserSubject.next({
			session:false,
		    username:"",
		    security:{},
		    nombre:"",
		    saldo:"",
		    puntos:"",
		    suscrito:false,
		    divisa:"",
		    totalProductos:0
		});
		this.newRouter.navigate([ '/' ]);
	}

	fnRecuperacion( newUser:User ){
		return this.fnRequestPost( environment.peticion.recuperacion, newUser );
	}

	fnActivarCuenta( newParams ){
		return this.fnRequestPost( environment.peticion.activarCuenta, newParams );
	}

	/* FUNCIONES RECUPERACION */
	fnSolicitudRecuperacion( newParams ){
		return this.fnRequestPost( environment.peticion.solicitudRecuperacion, newParams );
	}
	fnValidarSolicitud( newParams ){
		return this.fnRequestPost( environment.peticion.verificarSolicitud, newParams );
	}
	fnCambiarContrasena( newParams ){
		return this.fnRequestPost( environment.peticion.cambiarContrasena, newParams );
	}

	/* FUNCIONES REGISTRO */
	fnRegistrarCuenta( newParams ){
		return this.fnRequestPost( environment.peticion.crearCuentaOnline, newParams );
	}

	/* FUNCIONES HOME */
	fnGetCategorias( Categoria ){
		return this.fnRequestPost( environment.peticion.categorias, {categoria:Categoria.id} );
	}
	fnGetOfertas( newParams ){
		return this.fnRequestPost( environment.peticion.ofertasOnline, newParams );
	}
	fnGetSecciones( newParams ){
		return this.fnRequestPost( environment.peticion.seccionesOnline, newParams );
	}
	fnGetproductosMarca( newParams ){
		return this.fnRequestPost( environment.peticion.productosMarca, newParams );
	}
	fnGetAlimentos( newParams ){
		return this.fnRequestPost( environment.peticion.prodcutosAlimento, newParams );
	}
	fnGetSugerencias( newParams ){
		return this.fnRequestPost( environment.peticion.sugerenciasBusqueda, newParams );
	}

	/* FUNCIONES TIENDA */
	fnRangoPrecios( newParams ){
		return this.fnRequestPost( environment.peticion.rangoPreciosOnline, newParams );
	}
	fnCategoriasTienda(marca?:string){
		return this.fnRequestPost( environment.peticion.categoriasFiltrosTienda, {marca} );
	}
	fnMarcasTienda(){
		return this.fnRequestPost( environment.peticion.marcasOnline, {} );
	}
	fnInformacionMarca( alias : string){
		return this.fnRequestPost( environment.peticion.informacionMarca, {marca: {alias: alias}} );
	}
	fnProductosTienda( newParams ){
		newParams.productosUnicos = true;
		return this.fnRequestPost( environment.peticion.productosFiltradosOnline, newParams );
	}
	fnActualizarCantidadesFiltros( newParams ){
		return this.fnRequestPost( environment.peticion.actualizarCantidadesFiltros, newParams );
	}

	/* FUNCIONES PRODUCTO */
	fnInformacionProducto( newParams ){
		return this.fnRequestPost( environment.peticion.detalleProductoOnline, newParams );
	}
	fnGaleriaInventario( newParams ){
		return this.fnRequestPost( environment.peticion.fotografiasInventario, newParams );
	}
	fnProductosRelacionados( newParams ){
		return this.fnRequestPost( environment.peticion.productosRelacionados, newParams );
	}
	fnCragarResenias( newParams ){
		return this.fnRequestPost( environment.peticion.reseniasProducto, newParams );
	}
	fnPermisosProducto( newParams ){
		return this.fnRequestPost( environment.peticion.permisosProducto, newParams );
	}
	fnCargarpreguntas( newParams ){
		return this.fnRequestPost( environment.peticion.preguntasProducto, newParams );
	}

	fnWishlist( newParams ){
		return this.fnRequestPost( environment.peticion.wishlistProducto, newParams );
	}

	fnegistrarVisita( newParams ){
		return this.fnRequestPost( environment.peticion.nuevaVisita, newParams );
	}

	/* FUNCIONES CITA */
	fnGetSucursales(){
		return this.fnRequestPost( environment.peticion.sucursales, {} );
	}

	fnGetHorariosSucursal( newSucursal ){
		return this.fnRequestPost( environment.peticion.horariosSucursal, { sucursal: { id:newSucursal.id } } );
	}


	/* FUNCIONES CARRITO COMPRA */
	fnSubscriberCarrito(){
		return 
	}
	fnTotalProductosCarrito( newParams ){
		return this.fnRequestPost( environment.peticion.totalProductosCarrito, newParams );
	}
	fnRegistrarProducto( newParams ){
		return this.fnRequestPost( environment.peticion.registrarProducto, newParams );
	}
	fnCargarCarrito( newParams ){
		return this.fnRequestPost( environment.peticion.cargarCarrito, newParams );
	}
	fnCargarPreview( newParams ){
		return this.fnRequestPost( environment.peticion.previewInventarioDetalle, newParams );
	}
	fnCargarComprados( newParams ){
		return this.fnRequestPost( environment.peticion.productosComprados, newParams );
	}
	fnCargarDirecciones( newParams ){
		return this.fnRequestPost( environment.peticion.cargarDirecciones, newParams );
	}
	fnUpdateVentaDetalle( newParams ){
		return this.fnRequestPost( environment.peticion.updateProductoVenta, newParams );
	}
	fnAplicarCupon( newParams ){
		return this.fnRequestPost( environment.peticion.aplicarCupon, newParams );
	}
	fnVincularVentaCliente( newParams ){
		return this.fnRequestPost( environment.peticion.vincularVentaCliente, newParams );
	}
	fnTerminarVenta( newParams ){
		return this.fnRequestPost( environment.peticion.terminarVenta, newParams );
	}
	fnVincularDireccionVenta( newParams ){
		return this.fnRequestPost( environment.peticion.registrarDireccionVenta, newParams );
	}
	fnEliminarProducto( newParams ){
		return this.fnRequestPost( environment.peticion.eliminarProductoCarrito, newParams );
	}

	/* FUNCOINES PEDIDOS */
	fnCargarCompras( newParams ){
		return this.fnRequestPost( environment.peticion.ventasCliente, newParams );
	}
	fnInformacionCompra( newParams ){
		return this.fnRequestPost( environment.peticion.detalleVenta, newParams );
	}



	/* FUNCIONES BUEQUEDA PRODUCTO */
	fnBuscarProductos( newParams ){
		return this.fnRequestPost( environment.peticion.buscarProductos, newParams );
	}


	/* FUNCIONES API ASENTAMIENTO */
	fnBuscarColonias( newParams ){
		return this.fnRequestPost( environment.peticion.buscarColonias, newParams );
	}
	fnConsultarColonia( newParams ){
		return this.fnRequestPost( environment.peticion.consultarDireccion, newParams );
	}


	fnListarServiciosPaqueteria( newParams ){
		return this.fnRequestPost( environment.peticion.listarServiciosPaqueteria, newParams );
	}

	/* FUNCIONES PAQUETERIA */
	fnCotizarEnvio( newParams ){
		return this.fnRequestPost( environment.peticion.cotizarEnvio, newParams );
	}


	/* FUNCIONES NEWSLETTER */
	fnSuscribir( newParams ){
		return this.fnRequestPost( environment.peticion.suscribir, newParams );
	}
	fnDesuscribir( newParams ){
		return this.fnRequestPost( environment.peticion.desuscribir, newParams );
	}


	/* FUNCIONES MI CUENTA */
	fnCargarDatosPersonales(){
		return this.fnRequestPost( environment.peticion.cargarDatosPersonales, {} );
	}

	fnActualizarDatosPersonales( newParams ){
		return this.fnRequestPost( environment.peticion.actualizarDatosPersonales, newParams );
	}

	fnCambiarClave( newParams ){
		return this.fnRequestPost( environment.peticion.actualizarClave, newParams );
	}

	fnCargarDireccionesEnvio(){
		return this.fnRequestPost( environment.peticion.cargarDireccionesEnvio, {} );
	}

	fnActualizarDireccionEnvio( newParams ){
		return this.fnRequestPost( environment.peticion.actualizarDireccionEnvio, newParams );
	}

	fnEliminarDireccionEnvio( newParams ){
		return this.fnRequestPost( environment.peticion.eliminarDireccionEnvio, newParams );
	}

	fnCargarWishList( newParams ){
		return this.fnRequestPost( environment.peticion.listaWishList, newParams );
	}

	fnCargarPedidos( newParams ){
		return this.fnRequestPost( environment.peticion.paginarPedidos, newParams );
	}

	fnInformacionPedido( newParams ){
		return this.fnRequestPost( environment.peticion.informacionPedido, newParams );
	}

	fnCancelarCuenta( newParams ){
		return this.fnRequestPost( environment.peticion.cancelarCompraTerminada, newParams );
	}

	fnNavegacion( newParams ){
		return this.fnRequestPost( environment.peticion.navegacion, newParams );
	}

	fnEnvioContacto( newParams ){
		return this.fnRequestPost( environment.peticion.envioContacto, newParams );
	}


	fnGetMes( numero:number ){
		switch (numero) {
			case 0:
			return "Enero";
			break;
			case 1:
			return "Febrero";
			break;
			case 2:
			return "Marzo";
			break;
			case 3:
			return "Abril";
			break;
			case 4:
			return "Mayo";
			break;
			case 5:
			return "Junio";
			break;
			case 6:
			return "Julio";
			break;
			case 7:
			return "Agosto";
			break;
			case 8:
			return "Septiembre";
			break;
			case 9:
			return "Octubre";
			break;
			case 10:
			return "Noviembre";
			break;
			case 11:
			return "Diciembre";
			break;
		}
	}

	fnOrdenarLista( newLista:any[], newElement:string ){
		return newLista.sort((obj1, obj2) => {
			if (obj1[newElement] > obj2[newElement]) {
				return 1;
			}
			if (obj1[newElement] < obj2[newElement]) {
				return -1;
			}
			return 0;
		});
	}

	fnLatinize( newString:String ){
		var Latinise={
			latin_map:{"Á":"A","Ă":"A","Ắ":"A","Ặ":"A","Ằ":"A","Ẳ":"A","Ẵ":"A","Ǎ":"A","Â":"A","Ấ":"A","Ậ":"A","Ầ":"A","Ẩ":"A","Ẫ":"A","Ä":"A","Ǟ":"A","Ȧ":"A","Ǡ":"A","Ạ":"A","Ȁ":"A","À":"A","Ả":"A","Ȃ":"A","Ā":"A","Ą":"A","Å":"A","Ǻ":"A","Ḁ":"A","Ⱥ":"A","Ã":"A","Ꜳ":"AA","Æ":"AE","Ǽ":"AE","Ǣ":"AE","Ꜵ":"AO","Ꜷ":"AU","Ꜹ":"AV","Ꜻ":"AV","Ꜽ":"AY","Ḃ":"B","Ḅ":"B","Ɓ":"B","Ḇ":"B","Ƀ":"B","Ƃ":"B","Ć":"C","Č":"C","Ç":"C","Ḉ":"C","Ĉ":"C","Ċ":"C","Ƈ":"C","Ȼ":"C","Ď":"D","Ḑ":"D","Ḓ":"D","Ḋ":"D","Ḍ":"D","Ɗ":"D","Ḏ":"D","ǲ":"D","ǅ":"D","Đ":"D","Ƌ":"D","Ǳ":"DZ","Ǆ":"DZ","É":"E","Ĕ":"E","Ě":"E","Ȩ":"E","Ḝ":"E","Ê":"E","Ế":"E","Ệ":"E","Ề":"E","Ể":"E","Ễ":"E","Ḙ":"E","Ë":"E","Ė":"E","Ẹ":"E","Ȅ":"E","È":"E","Ẻ":"E","Ȇ":"E","Ē":"E","Ḗ":"E","Ḕ":"E","Ę":"E","Ɇ":"E","Ẽ":"E","Ḛ":"E","Ꝫ":"ET","Ḟ":"F","Ƒ":"F","Ǵ":"G","Ğ":"G","Ǧ":"G","Ģ":"G","Ĝ":"G","Ġ":"G","Ɠ":"G","Ḡ":"G","Ǥ":"G","Ḫ":"H","Ȟ":"H","Ḩ":"H","Ĥ":"H","Ⱨ":"H","Ḧ":"H","Ḣ":"H","Ḥ":"H","Ħ":"H","Í":"I","Ĭ":"I","Ǐ":"I","Î":"I","Ï":"I","Ḯ":"I","İ":"I","Ị":"I","Ȉ":"I","Ì":"I","Ỉ":"I","Ȋ":"I","Ī":"I","Į":"I","Ɨ":"I","Ĩ":"I","Ḭ":"I","Ꝺ":"D","Ꝼ":"F","Ᵹ":"G","Ꞃ":"R","Ꞅ":"S","Ꞇ":"T","Ꝭ":"IS","Ĵ":"J","Ɉ":"J","Ḱ":"K","Ǩ":"K","Ķ":"K","Ⱪ":"K","Ꝃ":"K","Ḳ":"K","Ƙ":"K","Ḵ":"K","Ꝁ":"K","Ꝅ":"K","Ĺ":"L","Ƚ":"L","Ľ":"L","Ļ":"L","Ḽ":"L","Ḷ":"L","Ḹ":"L","Ⱡ":"L","Ꝉ":"L","Ḻ":"L","Ŀ":"L","Ɫ":"L","ǈ":"L","Ł":"L","Ǉ":"LJ","Ḿ":"M","Ṁ":"M","Ṃ":"M","Ɱ":"M","Ń":"N","Ň":"N","Ņ":"N","Ṋ":"N","Ṅ":"N","Ṇ":"N","Ǹ":"N","Ɲ":"N","Ṉ":"N","Ƞ":"N","ǋ":"N","Ñ":"N","Ǌ":"NJ","Ó":"O","Ŏ":"O","Ǒ":"O","Ô":"O","Ố":"O","Ộ":"O","Ồ":"O","Ổ":"O","Ỗ":"O","Ö":"O","Ȫ":"O","Ȯ":"O","Ȱ":"O","Ọ":"O","Ő":"O","Ȍ":"O","Ò":"O","Ỏ":"O","Ơ":"O","Ớ":"O","Ợ":"O","Ờ":"O","Ở":"O","Ỡ":"O","Ȏ":"O","Ꝋ":"O","Ꝍ":"O","Ō":"O","Ṓ":"O","Ṑ":"O","Ɵ":"O","Ǫ":"O","Ǭ":"O","Ø":"O","Ǿ":"O","Õ":"O","Ṍ":"O","Ṏ":"O","Ȭ":"O","Ƣ":"OI","Ꝏ":"OO","Ɛ":"E","Ɔ":"O","Ȣ":"OU","Ṕ":"P","Ṗ":"P","Ꝓ":"P","Ƥ":"P","Ꝕ":"P","Ᵽ":"P","Ꝑ":"P","Ꝙ":"Q","Ꝗ":"Q","Ŕ":"R","Ř":"R","Ŗ":"R","Ṙ":"R","Ṛ":"R","Ṝ":"R","Ȑ":"R","Ȓ":"R","Ṟ":"R","Ɍ":"R","Ɽ":"R","Ꜿ":"C","Ǝ":"E","Ś":"S","Ṥ":"S","Š":"S","Ṧ":"S","Ş":"S","Ŝ":"S","Ș":"S","Ṡ":"S","Ṣ":"S","Ṩ":"S","Ť":"T","Ţ":"T","Ṱ":"T","Ț":"T","Ⱦ":"T","Ṫ":"T","Ṭ":"T","Ƭ":"T","Ṯ":"T","Ʈ":"T","Ŧ":"T","Ɐ":"A","Ꞁ":"L","Ɯ":"M","Ʌ":"V","Ꜩ":"TZ","Ú":"U","Ŭ":"U","Ǔ":"U","Û":"U","Ṷ":"U","Ü":"U","Ǘ":"U","Ǚ":"U","Ǜ":"U","Ǖ":"U","Ṳ":"U","Ụ":"U","Ű":"U","Ȕ":"U","Ù":"U","Ủ":"U","Ư":"U","Ứ":"U","Ự":"U","Ừ":"U","Ử":"U","Ữ":"U","Ȗ":"U","Ū":"U","Ṻ":"U","Ų":"U","Ů":"U","Ũ":"U","Ṹ":"U","Ṵ":"U","Ꝟ":"V","Ṿ":"V","Ʋ":"V","Ṽ":"V","Ꝡ":"VY","Ẃ":"W","Ŵ":"W","Ẅ":"W","Ẇ":"W","Ẉ":"W","Ẁ":"W","Ⱳ":"W","Ẍ":"X","Ẋ":"X","Ý":"Y","Ŷ":"Y","Ÿ":"Y","Ẏ":"Y","Ỵ":"Y","Ỳ":"Y","Ƴ":"Y","Ỷ":"Y","Ỿ":"Y","Ȳ":"Y","Ɏ":"Y","Ỹ":"Y","Ź":"Z","Ž":"Z","Ẑ":"Z","Ⱬ":"Z","Ż":"Z","Ẓ":"Z","Ȥ":"Z","Ẕ":"Z","Ƶ":"Z","Ĳ":"IJ","Œ":"OE","ᴀ":"A","ᴁ":"AE","ʙ":"B","ᴃ":"B","ᴄ":"C","ᴅ":"D","ᴇ":"E","ꜰ":"F","ɢ":"G","ʛ":"G","ʜ":"H","ɪ":"I","ʁ":"R","ᴊ":"J","ᴋ":"K","ʟ":"L","ᴌ":"L","ᴍ":"M","ɴ":"N","ᴏ":"O","ɶ":"OE","ᴐ":"O","ᴕ":"OU","ᴘ":"P","ʀ":"R","ᴎ":"N","ᴙ":"R","ꜱ":"S","ᴛ":"T","ⱻ":"E","ᴚ":"R","ᴜ":"U","ᴠ":"V","ᴡ":"W","ʏ":"Y","ᴢ":"Z","á":"a","ă":"a","ắ":"a","ặ":"a","ằ":"a","ẳ":"a","ẵ":"a","ǎ":"a","â":"a","ấ":"a","ậ":"a","ầ":"a","ẩ":"a","ẫ":"a","ä":"a","ǟ":"a","ȧ":"a","ǡ":"a","ạ":"a","ȁ":"a","à":"a","ả":"a","ȃ":"a","ā":"a","ą":"a","ᶏ":"a","ẚ":"a","å":"a","ǻ":"a","ḁ":"a","ⱥ":"a","ã":"a","ꜳ":"aa","æ":"ae","ǽ":"ae","ǣ":"ae","ꜵ":"ao","ꜷ":"au","ꜹ":"av","ꜻ":"av","ꜽ":"ay","ḃ":"b","ḅ":"b","ɓ":"b","ḇ":"b","ᵬ":"b","ᶀ":"b","ƀ":"b","ƃ":"b","ɵ":"o","ć":"c","č":"c","ç":"c","ḉ":"c","ĉ":"c","ɕ":"c","ċ":"c","ƈ":"c","ȼ":"c","ď":"d","ḑ":"d","ḓ":"d","ȡ":"d","ḋ":"d","ḍ":"d","ɗ":"d","ᶑ":"d","ḏ":"d","ᵭ":"d","ᶁ":"d","đ":"d","ɖ":"d","ƌ":"d","ı":"i","ȷ":"j","ɟ":"j","ʄ":"j","ǳ":"dz","ǆ":"dz","é":"e","ĕ":"e","ě":"e","ȩ":"e","ḝ":"e","ê":"e","ế":"e","ệ":"e","ề":"e","ể":"e","ễ":"e","ḙ":"e","ë":"e","ė":"e","ẹ":"e","ȅ":"e","è":"e","ẻ":"e","ȇ":"e","ē":"e","ḗ":"e","ḕ":"e","ⱸ":"e","ę":"e","ᶒ":"e","ɇ":"e","ẽ":"e","ḛ":"e","ꝫ":"et","ḟ":"f","ƒ":"f","ᵮ":"f","ᶂ":"f","ǵ":"g","ğ":"g","ǧ":"g","ģ":"g","ĝ":"g","ġ":"g","ɠ":"g","ḡ":"g","ᶃ":"g","ǥ":"g","ḫ":"h","ȟ":"h","ḩ":"h","ĥ":"h","ⱨ":"h","ḧ":"h","ḣ":"h","ḥ":"h","ɦ":"h","ẖ":"h","ħ":"h","ƕ":"hv","í":"i","ĭ":"i","ǐ":"i","î":"i","ï":"i","ḯ":"i","ị":"i","ȉ":"i","ì":"i","ỉ":"i","ȋ":"i","ī":"i","į":"i","ᶖ":"i","ɨ":"i","ĩ":"i","ḭ":"i","ꝺ":"d","ꝼ":"f","ᵹ":"g","ꞃ":"r","ꞅ":"s","ꞇ":"t","ꝭ":"is","ǰ":"j","ĵ":"j","ʝ":"j","ɉ":"j","ḱ":"k","ǩ":"k","ķ":"k","ⱪ":"k","ꝃ":"k","ḳ":"k","ƙ":"k","ḵ":"k","ᶄ":"k","ꝁ":"k","ꝅ":"k","ĺ":"l","ƚ":"l","ɬ":"l","ľ":"l","ļ":"l","ḽ":"l","ȴ":"l","ḷ":"l","ḹ":"l","ⱡ":"l","ꝉ":"l","ḻ":"l","ŀ":"l","ɫ":"l","ᶅ":"l","ɭ":"l","ł":"l","ǉ":"lj","ſ":"s","ẜ":"s","ẛ":"s","ẝ":"s","ḿ":"m","ṁ":"m","ṃ":"m","ɱ":"m","ᵯ":"m","ᶆ":"m","ń":"n","ň":"n","ņ":"n","ṋ":"n","ȵ":"n","ṅ":"n","ṇ":"n","ǹ":"n","ɲ":"n","ṉ":"n","ƞ":"n","ᵰ":"n","ᶇ":"n","ɳ":"n","ñ":"n","ǌ":"nj","ó":"o","ŏ":"o","ǒ":"o","ô":"o","ố":"o","ộ":"o","ồ":"o","ổ":"o","ỗ":"o","ö":"o","ȫ":"o","ȯ":"o","ȱ":"o","ọ":"o","ő":"o","ȍ":"o","ò":"o","ỏ":"o","ơ":"o","ớ":"o","ợ":"o","ờ":"o","ở":"o","ỡ":"o","ȏ":"o","ꝋ":"o","ꝍ":"o","ⱺ":"o","ō":"o","ṓ":"o","ṑ":"o","ǫ":"o","ǭ":"o","ø":"o","ǿ":"o","õ":"o","ṍ":"o","ṏ":"o","ȭ":"o","ƣ":"oi","ꝏ":"oo","ɛ":"e","ᶓ":"e","ɔ":"o","ᶗ":"o","ȣ":"ou","ṕ":"p","ṗ":"p","ꝓ":"p","ƥ":"p","ᵱ":"p","ᶈ":"p","ꝕ":"p","ᵽ":"p","ꝑ":"p","ꝙ":"q","ʠ":"q","ɋ":"q","ꝗ":"q","ŕ":"r","ř":"r","ŗ":"r","ṙ":"r","ṛ":"r","ṝ":"r","ȑ":"r","ɾ":"r","ᵳ":"r","ȓ":"r","ṟ":"r","ɼ":"r","ᵲ":"r","ᶉ":"r","ɍ":"r","ɽ":"r","ↄ":"c","ꜿ":"c","ɘ":"e","ɿ":"r","ś":"s","ṥ":"s","š":"s","ṧ":"s","ş":"s","ŝ":"s","ș":"s","ṡ":"s","ṣ":"s","ṩ":"s","ʂ":"s","ᵴ":"s","ᶊ":"s","ȿ":"s","ɡ":"g","ᴑ":"o","ᴓ":"o","ᴝ":"u","ť":"t","ţ":"t","ṱ":"t","ț":"t","ȶ":"t","ẗ":"t","ⱦ":"t","ṫ":"t","ṭ":"t","ƭ":"t","ṯ":"t","ᵵ":"t","ƫ":"t","ʈ":"t","ŧ":"t","ᵺ":"th","ɐ":"a","ᴂ":"ae","ǝ":"e","ᵷ":"g","ɥ":"h","ʮ":"h","ʯ":"h","ᴉ":"i","ʞ":"k","ꞁ":"l","ɯ":"m","ɰ":"m","ᴔ":"oe","ɹ":"r","ɻ":"r","ɺ":"r","ⱹ":"r","ʇ":"t","ʌ":"v","ʍ":"w","ʎ":"y","ꜩ":"tz","ú":"u","ŭ":"u","ǔ":"u","û":"u","ṷ":"u","ü":"u","ǘ":"u","ǚ":"u","ǜ":"u","ǖ":"u","ṳ":"u","ụ":"u","ű":"u","ȕ":"u","ù":"u","ủ":"u","ư":"u","ứ":"u","ự":"u","ừ":"u","ử":"u","ữ":"u","ȗ":"u","ū":"u","ṻ":"u","ų":"u","ᶙ":"u","ů":"u","ũ":"u","ṹ":"u","ṵ":"u","ᵫ":"ue","ꝸ":"um","ⱴ":"v","ꝟ":"v","ṿ":"v","ʋ":"v","ᶌ":"v","ⱱ":"v","ṽ":"v","ꝡ":"vy","ẃ":"w","ŵ":"w","ẅ":"w","ẇ":"w","ẉ":"w","ẁ":"w","ⱳ":"w","ẘ":"w","ẍ":"x","ẋ":"x","ᶍ":"x","ý":"y","ŷ":"y","ÿ":"y","ẏ":"y","ỵ":"y","ỳ":"y","ƴ":"y","ỷ":"y","ỿ":"y","ȳ":"y","ẙ":"y","ɏ":"y","ỹ":"y","ź":"z","ž":"z","ẑ":"z","ʑ":"z","ⱬ":"z","ż":"z","ẓ":"z","ȥ":"z","ẕ":"z","ᵶ":"z","ᶎ":"z","ʐ":"z","ƶ":"z","ɀ":"z","ﬀ":"ff","ﬃ":"ffi","ﬄ":"ffl","ﬁ":"fi","ﬂ":"fl","ĳ":"ij","œ":"oe","ﬆ":"st","ₐ":"a","ₑ":"e","ᵢ":"i","ⱼ":"j","ₒ":"o","ᵣ":"r","ᵤ":"u","ᵥ":"v","ₓ":"x"}
		};
		return newString.replace(/[^A-Za-z0-9\[\] ]/g,function(a){return Latinise.latin_map[a]||a})
	}

	fnLimpiarCarrito( newParams ) {
		return this.fnRequestPost( environment.peticion.limpiarCarrito, newParams );
	}
	fnValidarDisponibilidadProducto( newParams ){
		return this.fnRequestPost( environment.peticion.validarDisponibilidadProducto, newParams );
	}
	
}